export const MAX_FILE_SIZE_MB = 20;
export const MAX_FILES_COUNT = 5;
